import { Environments } from '@/config';
import { PARKVIEW_PRODUCTION } from './parkview.production';
import { PARKVIEW_STAGING } from './parkview.staging';

export const PARKVIEW = import.meta.env.MODE === Environments.PROD ? PARKVIEW_PRODUCTION : PARKVIEW_STAGING;
